// extracted by css-extract-rspack-plugin
export default {"chats":"chats-z98Rd7","loader":"loader-QglU8u","nextLoader":"nextLoader-Q4HUsj","empty":"empty-IRqxgq"};